import { useMemo } from 'react';

import { ProgressIndicatorItem } from 'components/ProgressIndicator';

export interface ProgressIndicatorHook {
  items: ProgressIndicatorItem[];
}

export type ApplyFinancePage = 'welcome' | 'terms' | 'form';

export default function useProgressIndicator(): ProgressIndicatorHook {
  const items: ProgressIndicatorItem[] = useMemo(
    () => [
      {
        type: 'single',
        active: false,
      },
      {
        type: 'multi',
        substeps: [
          {
            type: 'single',
            active: false,
          },
          {
            type: 'single',
            active: true,
          },
          {
            type: 'single',
            active: false,
          },
          {
            type: 'single',
            active: false,
          },
        ],
      },
      {
        type: 'single',
        active: false,
      },
    ],
    [],
  );

  return {
    items,
  };
}
